import ComponentePermissao from "@/Components/Base/Permissao/ComponentePermissao";
import Pagamento from "@/Models/Financeiro/Titulo/Pagamento/Pagamento";
import { useTituloPagamentoDesativar } from "@/Services/Financeiro/Titulo/Pagamento/PagamentoServices";
import { PropriedadesDeNotificacao } from "@/Utils/Notificacoes";
import { notification, Popconfirm, PopconfirmProps, Button } from "antd";
import { ReactNode } from "react";

interface ITituloPagamentoDesativarPopconfirmProps extends Omit<PopconfirmProps, "children" | "title"> {
    pagamento:Pagamento;
    children?:ReactNode;
    title?: React.ReactNode | (() => React.ReactNode);
    onSuccess?:() => void;
}
export default function TituloPagamentoDesativarPopconfirm({
    pagamento,
    children,
    title,
    description,
    onSuccess,
    ...rest
}:ITituloPagamentoDesativarPopconfirmProps) {
    title = title ?? "Desativar forma de pagamento";
    description = description ?? "Tem certeza de que deseja cancelar esta forma de pagamento?";

    const {
        mutate,
        isPending
    } = useTituloPagamentoDesativar({
        onSuccess() {
            notification.success({
                ...PropriedadesDeNotificacao["Sucesso"],
                message : "Forma de pagamento desativada com sucesso."
            });

            onSuccess?.();
        },
    });
    return <ComponentePermissao permissoes={["FinanceiroTituloNotaCancelar"]}>
        <Popconfirm
            {...rest}
            title={title}
            okText="Sim"
            description={description}
            onConfirm={() => {
                mutate(pagamento);
            }}
            destroyTooltipOnHide={false}
        >
            {children || <Button
                type='primary'
                loading={isPending}
                danger
                size='small'
            >Cancelar</Button>}
        </Popconfirm>
    </ComponentePermissao>;
}